import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PopupSessionService {
  private initializationDate: Date;
  private dismissedPopups: string[];

  constructor() {
    this.initializationDate = new Date();
    this.dismissedPopups = [];
  }

  public hasBeenDismissedForSession(popupName: string): boolean {
    return this.dismissedPopups.indexOf(popupName) !== -1;
  }

  public setDismissedForSession(popupName: string) {
    this.dismissedPopups.push(popupName);
  }
}
